import { Flex, Skeleton, Token } from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { messageBubbleMinHeight } from './components/MessageBubble'

interface ChatMessageLoadingProps {
  chatWidth?: number | string
  chatHeight?: number
  placement?: 'left' | 'right'
}

export const ChatMessageLoading: FC<ChatMessageLoadingProps> = ({
  chatWidth = '90%',
  chatHeight = messageBubbleMinHeight,
  placement = 'left',
}) => (
  <Flex width="100%" flexDirection={placement === 'right' ? 'row-reverse' : 'row'}>
    <Skeleton width={chatWidth} height={chatHeight} borderRadius={Token.radius.widget} />
  </Flex>
)
